import { AddNewsActionsProps } from "@bluframe/mightychroma-mightytool-frontend-types"

import AddActions from "./AddActions"

export interface Props extends AddNewsActionsProps {}

export interface ComponentProps extends Props {}

export default AddActions
